// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__HzEZW","label":"styles_label__QMpp5","icon":"styles_icon__JKdEN"};